import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../../interfaces';
import { API_KEYS } from '../../../../interfaces/api';
import { getApiState } from '../../../../redux/selectors/common';
import { showModal, hideModal } from '../../../../redux/slices/modal';
import { resetApiThunk } from '../../../../redux/thunks/api';
import { thunks } from '../../../../redux/thunks/thunks';
import { AddNonDocumentItem } from './AddNonDocumentItem';

const mapState = (state: AppState) => ({
  modal: state.modal,
  packageTypes: getApiState(state, API_KEYS.GET_SPECIAL_PACKAGES),
  shipmentRateState : getApiState(state, API_KEYS.GET_INTERNATIONAL_SHIPMENTS_RATE)
});

const mapDispatch = {
  getpackageTypes: thunks.GET_SPECIAL_PACKAGES,
  getShipmentRate : thunks.GET_INTERNATIONAL_SHIPMENTS_RATE,
  showModal,
  hideModal,
  resetApi: resetApiThunk,
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AddNonDocumentItem);
